import {DefaultToastContainer, DefaultToast} from 'react-toast-notifications';
import {styled} from '@mui/material/styles';

export const CustomToastContainer = styled(DefaultToastContainer)({
   '&&&': {
      zIndex: 1500,
   },
});

export const CustomToast = styled(DefaultToast)({
   '&&&': {
      // width: 'unset',
      // maxWidth: '80%',
      // minWidth: '350px',
      // maxHeight: '3rem',
      // textOverflow: 'ellipsis',
      // overflow: 'hidden',
      width: '40rem',
      '&>.react-toast-notifications__toast__content': {
         // textOverflow: 'ellipsis',
         // overflow: 'hidden',
         // whiteSpace: 'nowrap',
         width: '21rem',
         padding: '0.5rem',
         fontSize: '13px',
         whiteSpace: 'pre-wrap',
         // maxHeight: '6rem',
      },
   },
});

export const ToastListItem = styled(DefaultToast)({
   '&&&': {
      boxShadow: 'none',
      cursor: 'pointer',
      marginBottom: '0',
      // height: '100%',
      width: '40rem',
      borderRadius: '0',
      borderBottom: '2px solid white',
      '&>.react-toast-notifications__toast__icon-wrapper': {
         borderRadius: '0',
      },
      '&>.react-toast-notifications__toast__content': {
         // textOverflow: 'ellipsis',
         // overflow: 'hidden',
         // whiteSpace: 'nowrap',
         // maxHeight: '4rem',
         fontSize: '13px',
         whiteSpace: 'pre-wrap',
      },
   },
});
